

import React, { useEffect, useState } from "react";
import ReactSelect from "react-select";
import { customStyles } from "../../selectStyles";
import { useDispatch, useSelector } from "react-redux";
import { fetchJobTitleData } from "../../redux/actions/JobTitleActions";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { clearCityList, fetchCityData, selectCity } from "../../redux/actions/citiesAction";

const SidebarNew = (props) => {
	const dispatch = useDispatch();
	const { search } = useLocation();
	const queryParams = new URLSearchParams(search);
	const { cityList, loading } = useSelector((state) => state.cities);

	useEffect(() => {
		dispatch(fetchCityData())
	}, [dispatch])


	const city = queryParams.get("cityId") || "";
	const [isLoading, setIsLoading] = useState(false);
	const [cityId, setCityId] = useState("");

	const { jobTitleList } = useSelector((state) => state.jobTitle);
	useEffect(() => {
		dispatch(fetchJobTitleData());
	}, [dispatch]);

	const handleJobTitle = (selectedOption) => {
		console.log("Select Job Title===>", selectedOption)
		props.setSearchNew(selectedOption ? selectedOption.value : null);
	};
	const handleSearchInputChange = (inputValue) => {
		dispatch(fetchJobTitleData(inputValue));
	};

	const handleCitySelect = (selectedOption) => {
		// console.log("selectedOption", selectedOption);
		setCityId(...props.cityId, selectedOption ? selectedOption.value : "");
		dispatch(selectCity(selectedOption ? selectedOption.value : ""));
		// if(!selectedOption){
		// 	dispatch(clearCityList())
		// }
	};
	const handleCityInputChange = (inputValue) => {
		if (inputValue.length > 0) {  // Call API only if user types 3+ characters
			dispatch(fetchCityData(inputValue, 1, 500));
		}
	};

	const options = loading
		? [{ label: "Loading...", value: "" }]
		: cityList;

	console.log("props.cityIds", props.cityId)
	console.log("props.cityList", props.cityList)
	return (
		<>
			<div className="widget-filter st2 style-scroll settings SideBar-Search-Class">
				<form>
					<div className="group-form">
						<label className="title">Search job</label>
						<div className="group-input search-ip">
							{/* <button>
								<i className="icon-search"></i>
							</button>
							<input
								type="text"
								placeholder="Search Jobs"
								required
								className=" Dark-Input-from-group"
								onChange={(e) => {
									props.setSearchNew(e.target.value);
								}}
								value={props.searchNew}
							/> */}
							<ReactSelect
								options={jobTitleList}
								onChange={handleJobTitle}
								value={
									jobTitleList.find((option) => option.value === props.searchNew) || null
								}
								onInputChange={handleSearchInputChange}
								placeholder="Job Search"
								styles={customStyles}
								classNamePrefix="react-select"
								className="form-control  "
								isClearable
							/>
						</div>
					</div>
					<div className="group-form">
						<label className="title">Company</label>
						<div className="group-input has-icon Svg-Arrow-Class">
							<ReactSelect
								isMulti
								options={props.companiesList}
								onChange={props.handleCompany}
								value={
									//   props.getcompaniesList.find(
									//     (option) => option.value === props.selectedcompaniesId
									//   ) || null
									props.companiesList.filter((option) => props.companiesId.includes(option.value))
								}
								placeholder="Search & Select Company "
								styles={customStyles}
								classNamePrefix="react-select"
								className="form-control"
								isClearable

							/>
						</div>
					</div>

					<div className="group-form">
						<label className="title">City</label>
						<div className="group-input has-icon Svg-Arrow-Class">
							{/* <i className="icon-map-pin"></i> */}
							{/* <ReactSelect
								isMulti
								options={cityList}
								onChange={props.handleCitySelect}
								value={
									// props.cityList.filter((option) => props.cityIds.includes(option.value))
									cityList.filter((option) => cityList.includes(option.value) || option.value == city
									)
								}
								onInputChange={props.handleCityInputChange}
								placeholder="Search & Select City"
								styles={customStyles}
								classNamePrefix="react-select"
								className="form-control "
								// isClearable
								// closeMenuOnSelect={false}

							/> */}
							<ReactSelect
								isMulti
								options={options}
								onChange={(selectedOptions) => {
									if (!selectedOptions || selectedOptions.length === 0) {
										props.handleCitySelect([], true); // Empty list + pass flag
									} else {
										props.handleCitySelect(selectedOptions, false); // Normal selection
									}
								}}
								onInputChange={(inputValue, { action }) => {
									if (action === "input-change") {
										handleCityInputChange(inputValue);
									}
								}}
								value={cityList.filter((option) => props.cityIds.includes(option.value) || option.value === city)}
								placeholder="Search & Select City"
								styles={customStyles}
								classNamePrefix="react-select"
								className="form-control"
							/>
							{/* <SelectLocation /> */}
						</div>
					</div>

					<div className="group-form">
						<label className="title">Job types</label>
						<div className="group-input Svg-Arrow-Class">
							<ReactSelect
								options={props.jobTypeList}
								onChange={props.handleJobType}
								value={
									props.jobTypeList.filter((option) => props.selectedJobTypeId.includes(option.value))
								}
								placeholder="Search & Select Job Type"
								styles={customStyles}
								classNamePrefix="react-select"
								className="form-control"
								isClearable
								isMulti
							/>
						</div>
					</div>
					<div className="group-form">
						<label className="title">Work level type</label>
						<div className="group-input Svg-Arrow-Class">
							<ReactSelect
								options={props.workLevelList}
								onChange={props.handleWorkLevel}
								value={
									props.workLevelList.filter((option) => props.selectedworkLevelId.includes(option.value))
								}
								placeholder="Search & Select Work Level"
								styles={customStyles}
								classNamePrefix="react-select"
								className="form-control"
								isClearable
								isMulti
							/>
						</div>
					</div>

					<div className="group-form">
						<label className="title">Work location type</label>
						<div className="group-input Svg-Arrow-Class">
							<ReactSelect
								options={props.workLocation}
								onChange={props.handleWorkLocation}
								value={
									props.workLocation.filter((option) => props.selectedworkLocationId.includes(option.value))
								}
								placeholder="Search & Select Location"
								styles={customStyles}
								classNamePrefix="react-select"
								className="form-control"
								isClearable
								isMulti
							/>
						</div>
					</div>

					<div className="group-form">
						<label className="title"> Designation</label>
						<div className="group-input Svg-Arrow-Class">
							<ReactSelect
								options={props.designationList}
								onChange={props.handleDesignation}
								value={
									props.designationList.filter((option) => props.selectedDesignationId.includes(option.value))
								}
								placeholder="Search & Select Designation"
								styles={customStyles}
								classNamePrefix="react-select"
								className="form-control"
								isClearable
								isMulti
								menuPlacement="top" // This forces the dropdown to open upwards
							/>
						</div>
					</div>

					<div className="group-form salary-group-form">
						<label className="title">Salary type</label>
						<div className="group-input Svg-Arrow-Class">
							<ReactSelect
								options={props.salaryTypeList}
								onChange={props.handleSalaryType}
								value={
									props.salaryTypeList.filter((option) => props.selectedSalaryTypeId.includes(option.value))
								}
								placeholder="Search & Select Salary Type"
								styles={customStyles}
								classNamePrefix="react-select"
								className="form-control"
								isClearable
								isMulti
								menuPlacement="top" // This forces the dropdown to open upwards
							/>
						</div>
					</div>

				</form>
			</div>
		</>
	);
};

export default SidebarNew;
